import React from 'react';
import { useRecoilValue } from 'recoil';
import { isMobileState, isTabletState } from '../../recoil/selectors';
import { DesktopHeader } from './DesktopHeader/DesktopHeader';
import { MobileHeader } from './MobileHeader/MobileHeader';

export const MainHeader: React.FC = () => {
  const isMobile = useRecoilValue(isMobileState);
  const isTablet = useRecoilValue(isTabletState);
  return isMobile || isTablet ? <MobileHeader /> : <DesktopHeader />;
};

export default MainHeader;
